<template>
    <div>
        <!-- <div class='fw9 mb-3 gray'>Member List</div> -->
        <div v-for="(member, index) in members" :key="'member_'+member.id" >
            <div class='row mt-1'>
                <div class='col-12 col-lg-2'>
                    <h4 class='gray tl'>Atleta <span class='o-50' v-if="members.length > 1">{{ index+1 }}</span></h4>
                </div>
                <div class='col-12 col-lg-8'>
                    <member-form-new :memberId="member.id"  />  
                </div>
            </div>
            <hr v-if="members.length > 1" class='mb-5' />
        </div>
    </div>
</template>

<script>
export default {

    props:{
        members:{
            default:()=>[]
        }
    }
}
</script>

<style>

</style>
